import Popover from 'react-text-selection-popover';
import React from 'react';
import { RichUtils } from 'draft-js';
import { getSelectedLink, isMultilineSelection } from '../utilities/selectionUtilities';
import { BLOCK_TYPE, STYLE } from '../utilities/CONSTANTS';

import StyleButton from './StyleButton';

const INLINE_STYLES = [
    { label: 'B', style: STYLE.BOLD, className: 'icon-bold' },
    { label: 'i', style: STYLE.ITALIC, className: 'icon-italic' },
    { label: 'U', style: STYLE.UNDERLINE, className: 'icon-underline' },
    { label: ' S ', style: STYLE.STRIKETHROUGH, className: 'icon-strikethrough' },
    { label: '', style: STYLE.CODE, className: 'icon icon-code' },
    { label: '', style: STYLE.HIGHLIGHT, className: 'icon icon-highlight' },
];

const HEADER_BLOCK_TYPES = [
    { label: 'H1', style: BLOCK_TYPE.H1 },
    { label: 'H2', style: BLOCK_TYPE.H2 },
    { label: 'H3', style: BLOCK_TYPE.H3 },
];

const EXTRA_BLOCK_TYPES = [
    { label: 'Bullet', style: BLOCK_TYPE.UNORDERED_LIST, icon: 'list-unordered' },
    { label: 'List', style: BLOCK_TYPE.ORDERED_LIST, icon: 'list-ordered' },
    { label: 'Code', style: BLOCK_TYPE.CODE, icon: 'code' },
];

class HighlightControls extends React.Component {
    render() {
        const {
            editorState,
            toggleStyle,
            isOpen,
            toggleBlock,
            toggleLinkDialog,
        } = this.props;

        const currentStyle = editorState.getCurrentInlineStyle();
        const showBlockHighlightControls = isMultilineSelection(editorState);
        const blockType = RichUtils.getCurrentBlockType(editorState);

        const InlineStylesElement = INLINE_STYLES.map(type => (
            <StyleButton
                key={type.style}
                active={currentStyle.has(type.style)}
                label={type.label}
                style={type.style}
                className={type.className}
                onToggle={toggleStyle}
            />
        ));

        const HeaderBlocksElement = HEADER_BLOCK_TYPES.map(type => (
            <StyleButton
                key={type.label}
                active={type.style === blockType}
                label={type.label}
                style={type.style}
                onToggle={toggleBlock}
            />
        ));

        const ExtraBlocksElement = EXTRA_BLOCK_TYPES.map(type => (
            <div
                key={type.label}
                className={`block-button ${type.style === blockType ? 'active' : ''}`}
                onMouseDown={() => toggleBlock(type.style)}
            >
                <span className={`icon icon-${type.icon}`} />
            </div>
        ));

        // Handle weird behavior from #7540
        const onMouseDown = (e) => {
            e.preventDefault();
            e.nativeEvent.stopImmediatePropagation();
        };

        const onClick = (e) => {
            setTimeout(() => toggleLinkDialog(true), 1);
        };

        const LinkButton = (
            <div
                className={`block-button ${getSelectedLink(editorState) ? 'active' : ''}`}
                onClick={onClick}
                onMouseDown={onMouseDown}
            >
                <span className="icon icon-link" />
            </div>
        );

        const HighlightControlsElement = (
            <Popover isOpen={isOpen} className="highlight-controls">
                {InlineStylesElement}
                {HeaderBlocksElement}
                {LinkButton}
            </Popover>
        );

        const BlockHighlightControlsElement = (
            <Popover isOpen={isOpen} className="highlight-controls">
                {InlineStylesElement}
                {ExtraBlocksElement}
            </Popover>
        );

        return showBlockHighlightControls ? BlockHighlightControlsElement : HighlightControlsElement;
    }
}

export default HighlightControls;
